import {cipo} from 'cipo';

cipo.factory("AttachmentHandler", function (Model, URI, $window, PSPDFKIT_CONFIG, OFFICE_MIME_TYPES, AUDIO_MIME_TYPES, VIDEO_MIME_TYPES, $mdDialog, $http, Message, FileSaver, officeService, fileService) {
    //constructor extending Model
    var AttachmentHandler = Model.extend(function (obj) {
        var self = this;
        obj = obj || {};
        self.isLoading = obj.isLoading || null;

        // Private functions
        self.view = function (attachment) {
            if (self.isAudio(attachment) || self.isVideo(attachment)) {
                self.play(attachment);
            } else if (self.isPdfMarkupAttachment(attachment)) {
                self.viewPdfMarkup(attachment)
            } else {
                self.viewOffice(attachment);
            }
        }

        self.play = (attachment) => {
            self.isLoading(true);
            self[URI.MY_CIPO_DRIVE.GET_FILE_URL.method](`${URI.MY_CIPO_DRIVE.GET_FILE_URL}?versionId=${attachment.versionId}&isPreview=false`)
                .then((response) => {
                    $mdDialog.show({
                        locals: {
                            fileUrl: response?.url,
                            title: attachment.name,
                            mimeType: attachment.mimeType
                        },
                        controller: 'videoPlayerController',
                        templateUrl: '/ng/views/admin/modals/videoPlayer.html',
                        parent: angular.element(document.body),
                        fullscreen: true,
                        escapeToClose: false,
                        clickOutsideToClose: false,
                        disableParentScroll: true,
                        multiple: true
                    }).finally(() => self.manager.loading = false)
                })
        }

        self.viewPdfMarkup = function (attachment) {
            self.isLoading(true);
            self[URI.MY_CIPO_DRIVE.GET_FILE_URL.method](`${URI.MY_CIPO_DRIVE.GET_FILE_URL}?versionId=${attachment.versionId}&isPreview=false`)
                .then(function (response) {
                    self.isLoading(false);
                    $mdDialog.show({
                        locals: {
                            module: null,
                            entityInstanceId: 0,
                            documentId: null,
                            title: attachment.name,
                            fileUrl: response?.url,
                            fileId: attachment.id,
                            mimeType: attachment.mimeType
                        },
                        controller: 'pspdfkitViewerController',
                        templateUrl: '/ng/views/admin/modals/pspdfkitViewer.html',
                        parent: angular.element(document.body),
                        // targetEvent: event,
                        fullscreen: true,
                        escapeToClose: false,
                        clickOutsideToClose: false,
                        disableParentScroll: true,
                        multiple: true
                    })
                        .then(function (result) {

                        }, function () {
                        });

                    // If using inline file manager, update z-index of new dialog so it's on top
                    if ($('.inlineManagerWrapper').length) {
                        setTimeout(function () {
                            $('#pspdfkitViewerDialog').closest('.md-dialog-container').css('z-index', '100');
                        }, 200);
                    }
                })
                .catch(function (err) {
                    console.error(err);
                    self.isLoading(false);
                });
        }

        self.viewOffice = function (attachment) {
            officeService.open(attachment, true);
        }

        self.viewAttachments = function (attachment, list) {
            $mdDialog.show({
                locals: {
                    attachment: attachment,
                    list: list || [],
                },
                controller: 'pspdfkitAttachmentViewerController',
                templateUrl: '/ng/views/admin/modals/pspdfkitAttachmentViewer.html',
                parent: angular.element(document.body),
                // targetEvent: event,
                fullscreen: true,
                escapeToClose: false,
                clickOutsideToClose: false,
                disableParentScroll: true,
                multiple: true
            })
                .then(function (result) {

                }, function () {
                });

            // If using inline file manager, update z-index of new dialog so it's on top
            if ($('.inlineManagerWrapper').length) {
                setTimeout(function () {
                    $('#pspdfkitViewerDialog').closest('.md-dialog-container').css('z-index', '100');
                }, 200);
            }
        }

        self.preview = function (attachment) {
            self.isLoading(true);
            var uri = URI.MY_CIPO_DRIVE.GET_FILE_URL;
            self[uri.method](`${uri}?fileId=${attachment.id}&versionId=${attachment.versionId}&isPreview=true`)
                .then(function (response) {
                    $window.open(response?.url, "_blank");
                })
                .catch(function (e) {
                    Message.dberror(e);
                })
                .finally(function () { self.isLoading(false); });
        }
             
        self.isPdfMarkupAttachment = function (attachment) {
            return PSPDFKIT_CONFIG.MIME_TYPES.includes(attachment.mimeType);
        }
        
        self.isOfficeAttachment = function (attachment) {
            return OFFICE_MIME_TYPES.includes(attachment.mimeType);
        }
    
        self.isAudio = function (attachment) {
            return AUDIO_MIME_TYPES.includes(attachment.mimeType);
        }

        self.isVideo = function (attachment) {
            return VIDEO_MIME_TYPES.includes(attachment.mimeType);
        }

        self.canView = function (attachment) {
            return self.isPdfMarkupAttachment(attachment) || self.isOfficeAttachment(attachment) ||
                self.isAudio(attachment) || self.isVideo(attachment);
        }
        // End private functions
    });


    // Public functions
    AttachmentHandler.prototype.open = function (attachment) {
        var self = this;
        self.canView(attachment)
            ? self.view(attachment)
            : self.preview(attachment);
    }

    AttachmentHandler.prototype.openAttachment = function (attachment, list) {
        var self = this;
        self.viewAttachments(attachment, list);
    }

    AttachmentHandler.prototype.openInNewTab = function (attachment) {
        var self = this;
        self.preview(attachment);
    }

    AttachmentHandler.prototype.save = function (attachment) {
        var self = this;
        self.isLoading(true);

        if (attachment.length > 104857600) {

            var dataURL = URI.MY_CIPO_DRIVE.DOWNLOAD_ZIP_FILE;
            var toDownload = { filesId: [], foldersId: [], currentFolderId: attachment.parentId };
            toDownload.filesId.push(attachment.id);

            $http[dataURL.method](dataURL.toString(), toDownload, { responseType: "arraybuffer" })
                .then(function (result) {
                    fileService.handleDownloadResult(result);
                })
                .catch(function (e) {
                    Message.dberror(e);
                })
                .finally(function () { self.isLoading(false); });
        }
        else {
            var uri = URI.MY_CIPO_DRIVE.GET_FILE_URL;
            self[uri.method](`${uri}?fileId=${attachment.id}&versionId=${attachment.versionId}`)
                .then(function (response) {
                    try {
                        fileService.downloadFile(response?.url, attachment.name);
                    } catch (error) {
                        console.log(error);
                    }
                })
                .catch(function (e) {
                    Message.dberror(e);
                })
                .finally(function () { self.isLoading(false); });
        }
    }
    // End public functions

    return AttachmentHandler;
});
